import '@/core/popover/options/PopoverOptionsMenu.css'
import { useCallback, useRef, useState } from 'react'

type OpenPopover<T = void> = (anchor: Element, onResult?: (value: T) => void) => void
export type PopoverHooks<T = void> = {
  anchorEl: Element | undefined
  openPopover: OpenPopover<T>
  closePopover: () => void
  setResult: (selectedItem: T) => void
}

export function useOptionsPopover<T = void>(
  options: { closeOnSelect?: boolean } = {},
): PopoverHooks<T> {
  const { closeOnSelect = true } = options

  const [anchorEl, setAnchorEl] = useState<Element | undefined>(undefined)
  const onResultRef = useRef<((value: T) => void) | undefined>(undefined)

  const openPopover = useCallback((anchor: Element, onResult?: (value: T) => void) => {
    setAnchorEl(anchor)
    onResultRef.current = onResult
  }, [])

  const closePopover = useCallback(() => {
    setAnchorEl(undefined)
  }, [])

  const setResult = useCallback((selectedItem: T) => {
    onResultRef.current?.(selectedItem)
    onResultRef.current = undefined
    if (closeOnSelect) {
      setAnchorEl(undefined)
    }
  }, [])

  return { anchorEl, openPopover, closePopover, setResult }
}
